"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// This is done so that documenation can be generated
var validationPropTypes = {
  /**
   * The aspect ratio of an image
   */
  aspectRatio: _propTypes.default.shape({
    width: _propTypes.default.number,
    height: _propTypes.default.number
  }),

  /**
   * Override default error messages, this supports all the validations found in the enumeration.
   *
   * `import { validationNames } from "../Validations"`
   */
  errorMessages: _propTypes.default.object,

  /**
   * The maxiumn height for an image
   */
  maxHeight: _propTypes.default.number,

  /**
   * The miniumn height for an image
   */
  minHeight: _propTypes.default.number,

  /**
   * The maximum value for the input required
   */
  maxLength: _propTypes.default.number,

  /**
   * The minimum value for the input required
   */
  minLength: _propTypes.default.number,

  /**
   * The maximum value allows for the input
   */
  maxValue: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.number]),

  /**
   * The minimum vaue allowed for the input
   */
  minValue: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.number]),

  /**
   * The maxiumn width of an image
   */
  maxWidth: _propTypes.default.number,

  /**
   * The miniumn wideth of an image
   */
  minWidth: _propTypes.default.number,

  /**
   * The regular expression used to validated the value of the input. We expect the regular expression to be escaped. Please see examples below.
   *
   * - Not Escaped: `^\d{5}([\-]\d{4})?$`
   *
   * - Escaped: `^\\d{5}([\\-]\\d{4})?$`
   */
  regExpPattern: _propTypes.default.string,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * Validations to apply to the field.
   *
   * `async (value, props, component) => { return { error: ..., message: ..., validationName: ... } }`
   */
  validations: _propTypes.default.arrayOf(_propTypes.default.func),

  /**
   * The value of the component.
   */
  value: _propTypes.default.any
}; // This is done so that documentation can be generated
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var Validations = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Validations, _React$Component);

  var _super = _createSuper(Validations);

  function Validations() {
    (0, _classCallCheck2.default)(this, Validations);
    return _super.apply(this, arguments);
  }

  return Validations;
}(_react.default.Component);

(0, _defineProperty2.default)(Validations, "propTypes", validationPropTypes);
var _default = validationPropTypes;
exports.default = _default;